import React from 'react';
import './FactionDwarvesDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {
  DWARVES_MELEE_COMBAT_BONUS_ADJACENT_TO_MOUNTAIN,
  MINE_EXPLORATION_CONFIG
} from "../../../../configs/factions/dwarves";
import {MINUS_SIGN} from "../../../../constants/text";
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";

const FactionDwarvesDescription = () => {
  const exclamation = <img
    className="faction-description-icon
    faction-description-icon-margin-right"
    src="/img/icons/exclamation-mark.png"
    alt="Важное ограничение"
    title={'Важное ограничение'}
  />;
  const mine = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/mine.ecae90cd.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;
  const superMine = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/super_mine.7a4a81f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;


  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  const dice = <img
    className={'policy-description-icon'}
    src={'/img/icons/dice.png'}
    alt={'Бросок кости'}
    title={'Бросок кости'}
  />;

  const mineExplorationPrice =
    <CoinsStat
      text={MINE_EXPLORATION_CONFIG.priceCoins}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const quarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left-only'}
    src={'/img/hexes/quarter.f69660fa.png'}
    alt={'Квартал'}
    title={'Квартал'}
  />;

  const centralQuarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/icons/central quarter.7dd51bfd.png'}
    alt={'Центральный квартал'}
    title={'Центральный квартал'}
  />;

  const mineExploration = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/mine_exploration.9e85865b.png'}
    alt={'Рудник'}
    title={'Рудник'}
  />;
  const mineExplorationMarginLeft = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/icons/mine_exploration.9e85865b.png'}
    alt={'Рудник'}
    title={'Рудник'}
  />;

  const mountain = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/mountains/mountain_rock_1.862dc5c3.png'}
    alt={'Квартал'}
    title={'Квартал'}
  />;

  const damageBonus = <span className={'text-war'}>
    {`+${DWARVES_MELEE_COMBAT_BONUS_ADJACENT_TO_MOUNTAIN}`}
  </span>;
  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;

  const damageBonusValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damageBonus}
    icon={<>{damage}{melee}</>}
  />

  const diceValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-end'}
    value={'d6'}
    icon={dice}
  />

  const unitD8 = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-left dwarves-cavalry'}
    src={'/img/icons/unit d8 friend.png'}
    alt={'d8'}
    title={'Лёгкая Кавалерия'}
  />
  const unitD12 = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-left dwarves-cavalry'}
    src={'/img/icons/unit d12 friend.png'}
    alt={'d12'}
    title={'Тяжёлая Кавалерия'}
  />

  return (
    <>
      <div className="policy-description_line">
        В
        <span className={'text-construction policy-description-icon-margin-right-left'}>
          фазе Строительства
        </span>
        можно
      </div>
      <div className="policy-description_line">
        <span className={'text-coins-dark policy-description-icon-margin-right-left'}>
          разведать рудник
        </span>
        за {mineExplorationPrice}:
      </div>
      <div className="policy-description_line">
        {diceValueAndIcon}: 1-4 {MINUS_SIGN} {mine}, 5-6 {MINUS_SIGN} {superMine}.
      </div>
      <div className="policy-description_line">
        Этот {mineExploration} выставляется смежно {quarter} {centralQuarter},
      </div>
      <div className="policy-description_line">
        но не смежно другим {mineExplorationMarginLeft}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top">
        {unit} смежно {mountain} имеет {damageBonusValueAndIcon}.
      </div>
      <div className="faction-description_warning policy-description_line-margin-top">
        {exclamation} Нельзя нанимать {unitD8} {unitD12}.
      </div>
    </>
  );
};

export default FactionDwarvesDescription;
